<template>
    <div class="page">

        <!--        <div class="absBack">-->
        <!--            <div onclick="window.history.back()">-->
        <!--                <v-icon  medium dark>mdi-arrow-left</v-icon>-->
        <!--            </div>-->
        <!--        </div>-->


        <v-container>
            <h2 class="myTitle">Passwort zurücksetzen</h2>

            <div class="indented text-center" v-if="sended">
                <h4>Die E-Mail zum Zurücksetzen deines Passwortes wurde erfolgreich versendet an: {{email}}</h4>
            </div>

            <div class="indented text-center pa-3" v-else>
                Bitte gib deine E-Mail Adresse ein, um einen Link zum Zurücksetzen deines Passwortes zu erhalten:

                <div class="spacer-15"></div>

                <div style="margin: auto; width: 60%">
                    <v-text-field
                            class="roundInput"
                            v-model="email"
                            outlined
                            label="E-Mail"
                            outline hide-details
                    ></v-text-field>
                </div>

                <div class="spacer-25"></div>
                <div class="spacer-25"></div>
                <v-btn color="primary" rounded @click.native.passive="doResetPassword">Email zum Zurücksetzen senden
                </v-btn>
            </div>

            <div class="spacer-25"></div>
        </v-container>
    </div>
</template>

<script>
    import store from '../store/store'
    import {ebus} from '../vendor/ebus';
    import * as firebaseUtil from '../firebase/firebaseUtil'

    export default {
        name: "ResetPassword",

        data() {
            return {
                email: '',
                sended: false
            }
        },

        mounted() {
            this.sended = false;
        },

        methods: {
            doResetPassword() {

                if (/.+@.+/.test(this.email) === false) {
                    ebus.$emit('showInfo', {
                        title: 'Die E-Mail Adresse ist ungültig',
                        text: 'Bitte korrigiere deine Eingabe'
                    });
                    return;
                }

                var emailAddress = '' + this.email;

                firebaseUtil.resetEmail(emailAddress, (ok) => {
                    if (ok) {
                        // Email sent.
                        this.$nextTick(() => {
                            this.sended = true;
                        });
                    } else {
                        ebus.$emit('info', 'Fehler bei der Verabeitung');
                    }
                }).catch((error) => {
                });

            }
        }
    }
</script>

<style lang="scss" scoped>
    /*@import '../styles/sharedStyles';*/

</style>
